import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main_menu_container" }
const _hoisted_2 = { class: "notifications_hl_container" }
const _hoisted_3 = {
  key: 0,
  class: "notifications_hl_counter"
}
const _hoisted_4 = { class: "main_menu_link version_title" }

import { onMounted, reactive, ref } from 'vue';
    import MenuIcon from '../images/MenuIcon.vue';
    import { useRouter } from 'vue-router';
    //import { getDays } from '../../use/useTouchpointsHTTP';
    //import { IStatusDay } from '../../interfaces/status-day.interface';
    import { appStatus } from '../../use/useAppStatus';
    import NotificationBar from '../../components/PushNotification/NotificationBar.vue';
    import { useTouchpointsHTTP } from '../../use/useTouchpointsHTTP';

    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'MainMenu',
  setup(__props) {


    const packVer = JSON.stringify(require('../../../package.json'));

    console.log(JSON.parse(packVer).version);

    const state = reactive({
        isMenuOpened: false,
        showMenu: false,
        drag: false,
        notificationsCounter: 0
    });
    // eslint-disable-next-line
    const router = useRouter();

    const notificationData = ref(
        JSON.parse(localStorage.getItem('notificationData') || '[]').sort((a: { time: number; }, b: { time: number; }) => b.time - a.time)
    );

    onMounted(() => {
        //[Optimize API usage]-remove unused API call
        /*
        const username = window.localStorage.getItem("username")!;
        getDays(username).then((data) => {
            const result: IStatusDay[] = data!.data;
            // eslint-disable-next-line
            let completetedDays = 0;
            result.forEach((day) => {
                if(day.is_complete) {
                    completetedDays += 1;
                }
                // comeplete diary logic -> to be built
            });
        })
        */

        // notificationData.value.forEach((content: { viewed: boolean; }) => {
        //     if (content.viewed == false) {
        //         state.notificationsCounter++;
        //     } 
        // });

    })

    function onClickHandler(route: string) {
        if(route =='/privacy' || route== '/termsandconditions'){
            appStatus.hideAcceptAndRejectBTN = true;
        }         
        router.push(route);
        closeMenu();
    }

    function logOut() {
        window.localStorage.removeItem("userId")
        window.localStorage.removeItem("touchPointsLastLogin")
        window.localStorage.removeItem("username")
        window.localStorage.removeItem("touchPointsAuth")
        window.localStorage.removeItem("diaryStartDate")
        window.localStorage.removeItem("privacyAgree")
        window.localStorage.removeItem("trainingAgree")
        window.localStorage.removeItem("sleepTaskAgree")
        window.localStorage.removeItem("termAgree")
        window.localStorage.removeItem("dummyTimeslot")
        window.localStorage.removeItem("notificationData")
        window.localStorage.removeItem("termVer")
        window.localStorage.removeItem("pageReload")
        // window.localStorage.removeItem("checked_for_reset")
        window.localStorage.removeItem("fromWelcomePage")
        window.localStorage.removeItem("openedQuestion")
        window.localStorage.removeItem("fromTraining")
        window.localStorage.removeItem("privacyVer")
        window.localStorage.removeItem("subscription")
        window.localStorage.removeItem("PUBLIC_VAPID_KEY")
        window.localStorage.removeItem("current_timeslot_updated")
        window.localStorage.removeItem("diaryStarted")
        window.localStorage.removeItem("diaryStartDate")
        window.localStorage.removeItem("diaryId")
        window.localStorage.removeItem("session_id");
        location.reload(); // page need to be reloaded to clear cache after logout. [ATD-760]
        router.push({name: 'login'});
    }

    function removeMenuOnDrag(iteration: number, posDiff: number, element: HTMLElement) {
        if(posDiff - iteration >= -400) {
            iteration = iteration + 10;
            element.style.right = `${-posDiff-iteration}px`
            setTimeout(() => {
                removeMenuOnDrag(iteration, posDiff, element);
            }, 1);
        }
        else {
            state.isMenuOpened = false;
            return iteration;
        }
    }

    function regetMenuOnDrag(iteration: number, posDiff: number, element: HTMLElement) {
        if(-posDiff + iteration <= 0) {
            iteration = iteration + 5;
            element.style.right = `${(-posDiff + iteration) <= 0 ? -posDiff + iteration : 0}px`
            setTimeout(() => {
                regetMenuOnDrag(iteration, posDiff, element);
            }, 1);
        }
        else {
            return iteration;
        }
    }

    function openMenu() {
        if(state.isMenuOpened === false) {

            useTouchpointsHTTP().count_main_menu_clicks(localStorage.getItem("username")!);

            notificationData.value = JSON.parse(localStorage.getItem('notificationData') || '[]').sort((a: { time: number; }, b: { time: number; }) => b.time - a.time);

            notificationData.value.forEach((content: { viewed: boolean; }) => {
                if (content.viewed == false) {
                    state.notificationsCounter++;
                } 
            });         

            state.isMenuOpened = true
            state.showMenu = true
            setTimeout(() => {
                // eslint-disable-next-line
                let drag = false;
                let mousedown = false;
                let initialPos: number;
                let posDiff: number;
                const menu = document.getElementById("menu_content_container");
                menu?.classList.remove("show");
                menu?.addEventListener("touchstart", (event) => {
                    drag = false;
                    initialPos = event.changedTouches[0].screenX;
                    posDiff = 0;
                });
                if(window.innerWidth < 1000) {
                    menu?.addEventListener("touchmove", (event) => {
                    drag = true;
                    posDiff = event.changedTouches[0].screenX - initialPos;
                    if(posDiff <= 400 && posDiff >= 0) {
                        menu.style.right = `${-posDiff}px`;
                    }
                    });
                    menu?.addEventListener("touchend", () => {
                        initialPos = 0;
                        if(posDiff >= 145) {
                            removeMenuOnDrag(0, posDiff, menu);
                        }
                        else {
                            regetMenuOnDrag(0, posDiff, menu);
                        }
                    });
                }
                menu?.addEventListener('mousedown', (event) => {
                    drag = false;
                    mousedown = true;
                    initialPos = event.screenX;
                    posDiff = 0;
                });
                menu?.addEventListener('mousemove', (event) => {
                    drag = true;
                    if(mousedown) {
                        posDiff = event.screenX - initialPos;
                        if(posDiff <= 400 && posDiff >= 0) {
                            menu.style.right = `${-posDiff}px`;
                        }
                    }
                });
                menu?.addEventListener('mouseup', () => {
                    mousedown = false;
                    initialPos = 0;
                    if(posDiff >= 80) {
                        removeMenuOnDrag(0, posDiff, menu);
                    }
                    else {
                        regetMenuOnDrag(0, posDiff, menu);
                    }
                });
            }, 500);
        }
    }

    function closeMenu() {
        if(state.isMenuOpened === true) {
            state.showMenu = false
            setTimeout(() => {
                state.isMenuOpened = false
            }, 500);
        }
    }
    
    function updateSurveyWebsiteCount() {
        useTouchpointsHTTP().count_survey_web_hplk_clicks(localStorage.getItem("username")!);
    }

    function updateHowToVideosCount() {
        useTouchpointsHTTP().count_how_video_clicks(localStorage.getItem("username")!);
    }

    function updateFAQsCount() {
        useTouchpointsHTTP().count_faq_clicks(localStorage.getItem("username")!);
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NotificationBar),
    _createElementVNode("div", {
      class: "menu_image_container",
      onClick: _cache[0] || (_cache[0] = () => openMenu())
    }, [
      _createVNode(MenuIcon)
    ]),
    (state.isMenuOpened === true)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "main_menu_black_wrapper",
          onClick: _cache[1] || (_cache[1] = () => closeMenu())
        }))
      : _createCommentVNode("", true),
    (state.isMenuOpened === true)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["main_menu_content_container", {'show': state.showMenu === true, 'hide': state.showMenu === false}]),
          id: "menu_content_container"
        }, [
          _createElementVNode("p", {
            class: "main_menu_link",
            onClick: _cache[2] || (_cache[2] = () => onClickHandler('/welcomeback'))
          }, "Home page"),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", {
              class: "main_menu_link",
              onClick: _cache[3] || (_cache[3] = () => onClickHandler('/notifications'))
            }, "Notifications"),
            (state.notificationsCounter > 0 )
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(state.notificationsCounter), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", {
            class: "main_menu_link",
            onClick: _cache[4] || (_cache[4] = () => onClickHandler('/contactsupport'))
          }, "Contact Support/Restart diary"),
          _createElementVNode("a", {
            href: "https://touchpoints.ipsos.com/",
            onClick: _cache[5] || (_cache[5] = () => updateSurveyWebsiteCount()),
            style: {"text-decoration":"none"},
            target: "_blank"
          }, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("p", { class: "main_menu_link" }, "About TouchPoints", -1)
          ]))]),
          _createElementVNode("a", {
            href: "https://touchpoints.ipsos.com/how-to-videos",
            onClick: _cache[6] || (_cache[6] = () => updateHowToVideosCount()),
            style: {"text-decoration":"none"},
            target: "_blank"
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("p", { class: "main_menu_link" }, "How to videos", -1)
          ]))]),
          _createElementVNode("a", {
            href: "https://touchpoints.ipsos.com/faqs/",
            onClick: _cache[7] || (_cache[7] = () => updateFAQsCount()),
            style: {"text-decoration":"none"},
            target: "_blank"
          }, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("p", { class: "main_menu_link" }, "FAQs", -1)
          ]))]),
          _createElementVNode("p", {
            class: "main_menu_link",
            onClick: _cache[8] || (_cache[8] = () => onClickHandler('/privacy'))
          }, "Privacy"),
          _createElementVNode("p", {
            class: "main_menu_link",
            onClick: _cache[9] || (_cache[9] = () => onClickHandler('/termsandconditions'))
          }, "Terms and Conditions"),
          _createElementVNode("p", {
            class: "main_menu_link logout_button",
            onClick: _cache[10] || (_cache[10] = () => logOut())
          }, "Logout"),
          _createElementVNode("p", _hoisted_4, "Version " + _toDisplayString(JSON.parse(_unref(packVer)).version), 1)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})